<template lang="pug">
    section.ai-midjourney-info.section
        ._wrap.wrap
            h2._title {{ content.title }}
            ._description
                p._p(v-for="(text, index) in content.paragraphs" :key="index") {{ text }}
</template>

<script>
import aiStatic from "@/seo/ai-static.json";

export default {
    name: "AiMidjourneyInfo",
    data() {
        // Текст лежит в ai-static.json: тот же файл использует выгрузка HTML для поисковых ботов
        return { content: aiStatic.midjourneyInfo };
    },
};
</script>

<style lang="scss">
.ai-midjourney-info {
    $root: &;
    padding: 65px 0;
    line-height: 1.3;

    @media (max-width: 699px) {
        padding: 35px 0;
    }

    &__wrap {
        flex-direction: column;
        align-items: center;
    }

    &__title {
        font-size: 50px;
        color: #fff;
        width: 100%;
        font-weight: 400;
        flex: none;
        text-align: center;

        @media (max-width: 1149px) {
            font-size: 43px;
        }
        @media (max-width: 699px) {
            font-size: 30px;
            b {
                font-weight: 500;
            }
        }
    }

    &__description {
        margin-top: 70px;
        background: #141414;
        border: 1px solid #2e2e2e;
        border-radius: 10px;
        padding: 20px;

        @media (max-width: 879px) {
            margin-top: 50px;
        }
        @media (max-width: 699px) {
            margin-top: 30px;
            padding: 15px;
        }
    }

    &__p {
        color: #fff;
        font-size: 21px;

        &:not(:first-child) {
            margin-top: 16px;
        }

        @media (max-width: 699px) {
            font-size: 16px;
        }
    }
}
</style>
